import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetEcommerceSettingsApplicationErrors,
  GetEcommerceSettingsResponse,
  RequestedFieldsWithLiterals,
  getEcommerceSettings as universalGetEcommerceSettings,
} from './ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getEcommerceSettings(
  httpClient: HttpClient
): GetEcommerceSettingsSignature {
  return (fields: RequestedFieldsWithLiterals[]) =>
    universalGetEcommerceSettings(
      fields,
      // @ts-ignore
      { httpClient }
    );
}

interface GetEcommerceSettingsSignature {
  /**
   * Retrieves site eCommerce settings.
   * @param - Fields to include in the response.
   */
  (fields: RequestedFieldsWithLiterals[]): Promise<
    NonNullablePaths<
      GetEcommerceSettingsResponse,
      `errors` | `errors.${number}.requestedField`,
      4
    > & {
      __applicationErrorsType?: GetEcommerceSettingsApplicationErrors;
    }
  >;
}

export {
  AccountInfo,
  ActionEvent,
  ActiveProvider,
  Address,
  Alignment,
  App,
  AssignedFromFloatingReason,
  BackgroundFill,
  BackgroundFillOptionsOneOf,
  BooleanFeature,
  BusinessProperties,
  CancelRequestedReason,
  CheckboxField,
  CheckoutBillingFields,
  CheckoutBrand,
  CheckoutFields,
  CheckoutFooter,
  CheckoutGlobal,
  CheckoutHeader,
  CheckoutMain,
  CheckoutPolicies,
  CheckoutSettings,
  ContactUsPolicy,
  ContinueShopping,
  ContractSwitchClassification,
  ContractSwitchedReason,
  CountryDeliveryProperties,
  CustomCheckoutPolicy,
  CustomTag,
  DeliveryConfiguration,
  DeliveryDestinationProperties,
  Destination,
  DestinationScope,
  DigitalItemPolicy,
  DiscountRulesConfiguration,
  DisplayType,
  DomainEvent,
  DomainEventBodyOneOf,
  EcomSitePropertiesChangedEvent,
  EcommerceSettings,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  Error,
  ExpressButtonsCornerRadius,
  Feature,
  FeatureCancelled,
  FeatureCancelledReasonOneOf,
  FeatureContext,
  FeatureDisabled,
  FeatureDisabledReasonOneOf,
  FeatureEnabled,
  FeatureEnabledReasonOneOf,
  FeatureEvent,
  FeatureEventEventOneOf,
  FeaturePeriod,
  FeatureQuantityInfoOneOf,
  FeatureQuotaUsageChanged,
  FeatureUpdated,
  FeatureUpdatedPreviousQuantityInfoOneOf,
  FeatureUpdatedReasonOneOf,
  File,
  FocalPoint,
  GetEcommerceSettingsRequest,
  GetEcommerceSettingsResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  InputFieldBackgroundStyle,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  Locale,
  Logo,
  LogoSize,
  ManualFeatureCreationReason,
  ManualSyncReason,
  MessageEnvelope,
  MigratedFromLegacyReason,
  NewFeatureReason,
  Page,
  Pages,
  PrivacyPolicy,
  QuotaExhaustedReason,
  QuotaFeature,
  QuotaInfo,
  QuotaInfoEntry,
  ReassignedFromSiteReason,
  ReassignedToAnotherSiteReason,
  ReplacedByAnotherSubscriptionReason,
  RequestedFields,
  RestoreInfo,
  ReturnPolicy,
  ServicePluginConfiguration,
  StreetAddress,
  SubdivisionDeliveryProperties,
  TaxConfiguration,
  TermsAndConditionsPolicy,
  TransferredFromAnotherAccountReason,
  TransferredToAnotherAccountReason,
  TriggerFlow,
  URI,
  URIs,
  UnAssingedToFloatingReason,
  WebhookIdentityType,
} from './ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';
